import { render, staticRenderFns } from "./TheSignUpView.vue?vue&type=template&id=31a6c0d4"
import script from "./TheSignUpView.vue?vue&type=script&lang=js"
export * from "./TheSignUpView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports